/**
 * SalesforceIcon/index.js
 * desc: Salesforce company logo without text
 * note: brand icon via IconButton; carries an accessible name (aria-label when interactive) but
 *       no tooltip, matching the brand logos. Renders a button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import './styles.css';


const SalesforceIcon = (props) => (
    <IconButton baseClassName="salesforce icon" label="Salesforce" tooltip={ null } { ...props }>
        <svg viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg"><path d="M9.987 1.805A4.236 4.236 0 0113.031.518a4.26 4.26 0 013.702 2.162 5.181 5.181 0 012.093-.438C21.683 2.242 24 4.545 24 7.385s-2.317 5.142-5.174 5.142c-.342 0-.684-.033-1.02-.1a3.79 3.79 0 01-3.3 1.91 3.81 3.81 0 01-1.655-.376 4.318 4.318 0 01-3.972 2.59 4.314 4.314 0 01-4.05-2.782c-.266.055-.54.084-.823.084A3.997 3.997 0 010 9.865C0 8.39.806 7.1 2.003 6.411a4.508 4.508 0 01-.384-1.824C1.62 2.053 3.707 0 6.281 0a4.68 4.68 0 013.706 1.805z" /></svg>
    </IconButton>
);


export default SalesforceIcon;
